import { forwardRef, type SVGProps } from 'react'

interface PatientListIconProps extends SVGProps<SVGSVGElement> {}

export const PatientListIcon = forwardRef<SVGSVGElement, PatientListIconProps>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="currentColor"
        {...props}
      >
        <path d="M637.4-407.69q-43.55 0-74.13-30.49t-30.58-74.04q0-43.55 30.49-74.12 30.49-30.58 74.04-30.58 43.55 0 74.13 30.48 30.57 30.49 30.57 74.04 0 43.55-30.48 74.13-30.49 30.58-74.04 30.58zM448.85-183.08q-15.37 0-25.76-10.39-10.4-10.4-10.4-25.76v-24.46q0-17.03 8.27-32.44 8.27-15.41 22.81-24.48 43.46-25.47 91.73-38.58 48.28-13.12 101.81-13.12t101.8 13.12q48.27 13.11 91.74 38.58 14.53 9.07 22.8 24.48 8.27 15.41 8.27 32.44v24.46q0 15.36-10.39 25.76-10.4 10.39-25.76 10.39H448.85zm27.53-66.15v6.15h321.85v-6.15q-37.31-21.16-78.04-32.12-40.73-10.96-82.88-10.96-42.16 0-82.89 10.96-40.73 10.96-78.04 32.12zm160.93-218.46q18.54 0 31.57-13.04 13.04-13.04 13.04-31.58t-13.04-31.57q-13.03-13.04-31.57-13.04t-31.58 13.04q-13.04 13.03-13.04 31.57t13.04 31.58q13.04 13.04 31.58 13.04zm0-44.62zm0 269.23zM407.69-410h-240q-12.75 0-21.37-8.63-8.63-8.63-8.63-21.38 0-12.76 8.63-21.37 8.62-8.62 21.37-8.62h240q12.75 0 21.38 8.63 8.62 8.63 8.62 21.38 0 12.76-8.62 21.37-8.63 8.62-21.38 8.62zm160-320h-400q-12.75 0-21.37-8.63-8.63-8.63-8.63-21.38 0-12.76 8.63-21.37 8.62-8.62 21.37-8.62h400q12.75 0 21.38 8.63 8.62 8.63 8.62 21.38 0 12.76-8.62 21.37-8.63 8.62-21.38 8.62zM455.92-570H167.69q-12.75 0-21.37-8.63-8.63-8.63-8.63-21.38 0-12.76 8.63-21.37 8.62-8.62 21.37-8.62h317.7q-10.54 13.15-17.7 27.96-7.15 14.81-11.77 32.04z" />
      </svg>
    )
  },
)

PatientListIcon.displayName = 'PatientListIcon'
